import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { Button } from 'UI';
import type {
  PartnerAccountsRequest,
  PartnerAccountStatusFilter,
} from '@/components/Entities/hooks/useApi/useFetchPartnerAccounts';
import useAccountFilterFormConfig from './useAccountFilterFormConfig';
import styles from './AccountsList.module.scss';

const cn = withStyles(styles);

type AccountSearchFormProps = {
  country: string;
  status: PartnerAccountStatusFilter;
  searchText: string;
  currency: string;
  onAccountSearch: (values: PartnerAccountsRequest) => void;
};

export default function AccountSearchForm({
  country,
  status,
  searchText,
  currency,
  onAccountSearch,
}: AccountSearchFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.List.SearchForm' });

  const { ctx, renderFormElements } = useAccountFilterFormConfig({
    initialValues: { Country: country, Currency: currency, Status: status, SearchText: searchText },
    onSubmit: (values) =>
      onAccountSearch({
        Country: values.Country,
        Currency: values.Currency,
        VopayAccountStatus: values.Status,
        SearchText: values.SearchText,
      }),
  });

  return (
    <form onSubmit={ctx.handleSubmit} className={cn('searchArea')}>
      {renderFormElements()}

      <Button id="account-transactions-search" type="submit" colorScheme="primary" size="small">
        {t('searchButton')}
      </Button>
    </form>
  );
}
